import { getBaseUrl, getLocationOrigin } from '@/core/helpers/utils';

// https://cli.vuejs.org/guide/mode-and-env.html#environment-variables
// If project is build use 'serve' command (isDev), automatically will
// be used variables from .env file.
// You can locally override them in .env.local file, and this will be ignored by git.

const isDev = process.env.NODE_ENV === 'development';
const remoteHost = isDev
    ? process.env.VUE_APP_REMOTE_HOST
    : getLocationOrigin();
const applicationHost = getBaseUrl();
const ContextUploadTimeout = 300000; // 5 minutes
const maxSizeTileData = 1000; // кол-во символов строки
const tileDataExceptions = ['operations-chart-page']; // исключения, в виде name тайла, которые не будут сохраняться

export default {
    remoteHost,
    auth: {
        authority: `${remoteHost}/`,
        client_id: 'PWA',
        response_type: 'code',
        scope: 'openid profile api',
        filterProtocolClaims: true,
        loadUserInfo: true,
        automaticSilentRenew: true,
        revokeAccessTokenOnSignout: true,
        redirect_uri: `${applicationHost}auth-callback`,
        silent_redirect_uri: `${applicationHost}silent-callback`,
        post_logout_redirect_uri: `${applicationHost}`
    },
    events: {
        signalRReconnectTimeout: 5 * 1000, // 5 seconds
        mapResizeDelay: 200, // 200 ms
        chartResizeDelay: 200, // 200 ms
        // кол-во попыток автоматических попыток восстановить связь,
        // после истечения статус из временной потери связи переходит в статус разрыва соединения
        countTryConnection: 3
    },
    fetch: {
        apiPrefix: '/api/v2',
        syntaskHost: process.env.VUE_APP_SYNTASK_HOST
    },
    ContextUploadTimeout,
    tileData: {
        maxSizeTileData,
        tileDataExceptions
    }
};
